module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/amanda-jobbins.caa03ff1.png";